import { consumeBookingSearch } from "@/lib/bookingSearch/consume"
import { consumeIsSmallDevice } from "@/lib/consume/isSmallDevice"
import { consumeRouter } from "@/lib/consume/router"
import { consumeGeolocation } from "@/lib/geolocation/consume"
import { consumeServices } from "@/lib/services/consume"

import { BookingSearchComponent } from "@/components/Booking/BookingSearch/component"

export const BookingSearchConsumer = consumeRouter(
  consumeServices(
    consumeGeolocation(
      consumeBookingSearch(consumeIsSmallDevice(BookingSearchComponent))
    )
  )
)
